import * as euLibNew from '../../../../../assets/signWidget/eusign_new';

export const IFRAME_CONTAINER = 'sign-widget-parent';
export const WIDGET_ID = 'sign-widget';
export const external = true;
export const asBase64String = true;
export const previousSign: null = null;

export const { lib, signAlgo, signType, WIDGET_URI } = {
  WIDGET_URI: 'https://id.gov.ua/sign-widget/v20220527/',
  lib: euLibNew,
  signAlgo: euLibNew.EndUser.SignAlgo.DSTU4145WithGOST34311,
  signType: euLibNew.EndUser.SignType.CAdES_X_Long,
};
